var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-modal",
    {
      attrs: {
        title: "标准详情",
        okText: "确认",
        cancelText: "取消",
        width: "700px",
        visible: _vm.visible,
        "confirm-loading": _vm.confirmLoading,
      },
      on: { ok: _vm.handleOk, cancel: _vm.handleCancel },
    },
    [
      _c(
        "a-form-model",
        {
          ref: "ruleForm",
          attrs: {
            model: _vm.formState,
            rules: _vm.rules,
            "label-col": { span: 8 },
            "wrapper-col": { span: 16 },
          },
        },
        [
          _c(
            "a-row",
            [
              _c(
                "a-col",
                { attrs: { span: "24" } },
                [
                  _c(
                    "a-form-model-item",
                    {
                      attrs: {
                        labelCol: { span: 4 },
                        wrapperCol: { span: 20 },
                        label: "污染物CAS码",
                        prop: "badCas",
                      },
                    },
                    [
                      _c("a-input", {
                        model: {
                          value: _vm.formState.badCas,
                          callback: function ($$v) {
                            _vm.$set(_vm.formState, "badCas", $$v)
                          },
                          expression: "formState.badCas",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-row",
            [
              _c(
                "a-col",
                { attrs: { span: "24" } },
                [
                  _c(
                    "a-form-model-item",
                    {
                      attrs: {
                        labelCol: { span: 4 },
                        wrapperCol: { span: 20 },
                        label: "污染物（中文名）",
                        prop: "badCn",
                      },
                    },
                    [
                      _c("a-input", {
                        model: {
                          value: _vm.formState.badCn,
                          callback: function ($$v) {
                            _vm.$set(_vm.formState, "badCn", $$v)
                          },
                          expression: "formState.badCn",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-row",
            [
              _c(
                "a-col",
                { attrs: { span: "24" } },
                [
                  _c(
                    "a-form-model-item",
                    {
                      attrs: {
                        labelCol: { span: 4 },
                        wrapperCol: { span: 20 },
                        label: "污染物（英文名）",
                        prop: "badEn",
                      },
                    },
                    [
                      _c("a-input", {
                        model: {
                          value: _vm.formState.badEn,
                          callback: function ($$v) {
                            _vm.$set(_vm.formState, "badEn", $$v)
                          },
                          expression: "formState.badEn",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-row",
            [
              _c(
                "a-col",
                { attrs: { span: "24" } },
                [
                  _c(
                    "a-form-model-item",
                    {
                      attrs: {
                        labelCol: { span: 4 },
                        wrapperCol: { span: 20 },
                        label: "农产品分类",
                        prop: "produceType",
                      },
                    },
                    [
                      _c("a-input", {
                        model: {
                          value: _vm.formState.produceType,
                          callback: function ($$v) {
                            _vm.$set(_vm.formState, "produceType", $$v)
                          },
                          expression: "formState.produceType",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-row",
            [
              _c(
                "a-col",
                { attrs: { span: "24" } },
                [
                  _c(
                    "a-form-model-item",
                    {
                      attrs: {
                        labelCol: { span: 4 },
                        wrapperCol: { span: 20 },
                        label: "农产品名称",
                        prop: "produceName",
                      },
                    },
                    [
                      _c("a-input", {
                        model: {
                          value: _vm.formState.produceName,
                          callback: function ($$v) {
                            _vm.$set(_vm.formState, "produceName", $$v)
                          },
                          expression: "formState.produceName",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-row",
            [
              _c(
                "a-col",
                { attrs: { span: "24" } },
                [
                  _c(
                    "a-form-model-item",
                    {
                      attrs: {
                        labelCol: { span: 4 },
                        wrapperCol: { span: 20 },
                        label: "主要用途",
                        prop: "mainUse",
                      },
                    },
                    [
                      _c("a-input", {
                        model: {
                          value: _vm.formState.mainUse,
                          callback: function ($$v) {
                            _vm.$set(_vm.formState, "mainUse", $$v)
                          },
                          expression: "formState.mainUse",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-row",
            [
              _c(
                "a-col",
                { attrs: { span: "24" } },
                [
                  _c(
                    "a-form-model-item",
                    {
                      attrs: {
                        labelCol: { span: 4 },
                        wrapperCol: { span: 20 },
                        label: "每日允许摄入量",
                        prop: "dayLimit",
                      },
                    },
                    [
                      _c("a-input", {
                        model: {
                          value: _vm.formState.dayLimit,
                          callback: function ($$v) {
                            _vm.$set(_vm.formState, "dayLimit", $$v)
                          },
                          expression: "formState.dayLimit",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-row",
            [
              _c(
                "a-col",
                { attrs: { span: "24" } },
                [
                  _c(
                    "a-form-model-item",
                    {
                      attrs: {
                        labelCol: { span: 4 },
                        wrapperCol: { span: 20 },
                        label: "残留物",
                        prop: "canliuwu",
                      },
                    },
                    [
                      _c("a-input", {
                        model: {
                          value: _vm.formState.canliuwu,
                          callback: function ($$v) {
                            _vm.$set(_vm.formState, "canliuwu", $$v)
                          },
                          expression: "formState.canliuwu",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-row",
            [
              _c(
                "a-col",
                { attrs: { span: "24" } },
                [
                  _c(
                    "a-form-model-item",
                    {
                      attrs: {
                        labelCol: { span: 4 },
                        wrapperCol: { span: 20 },
                        label: "最大残留量",
                        prop: "canliuLimit",
                      },
                    },
                    [
                      _c("a-input", {
                        model: {
                          value: _vm.formState.canliuLimit,
                          callback: function ($$v) {
                            _vm.$set(_vm.formState, "canliuLimit", $$v)
                          },
                          expression: "formState.canliuLimit",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-row",
            [
              _c(
                "a-col",
                { attrs: { span: "24" } },
                [
                  _c(
                    "a-form-model-item",
                    {
                      attrs: {
                        labelCol: { span: 4 },
                        wrapperCol: { span: 20 },
                        label: "单位",
                        prop: "unit",
                      },
                    },
                    [
                      _c("a-input", {
                        model: {
                          value: _vm.formState.unit,
                          callback: function ($$v) {
                            _vm.$set(_vm.formState, "unit", $$v)
                          },
                          expression: "formState.unit",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-row",
            [
              _c(
                "a-col",
                { attrs: { span: "24" } },
                [
                  _c(
                    "a-form-model-item",
                    {
                      attrs: {
                        labelCol: { span: 4 },
                        wrapperCol: { span: 20 },
                        label: "监测方法",
                        prop: "checkFunc",
                      },
                    },
                    [
                      _c("a-input", {
                        model: {
                          value: _vm.formState.checkFunc,
                          callback: function ($$v) {
                            _vm.$set(_vm.formState, "checkFunc", $$v)
                          },
                          expression: "formState.checkFunc",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-row",
            [
              _c(
                "a-col",
                { attrs: { span: "24" } },
                [
                  _c(
                    "a-form-model-item",
                    {
                      attrs: {
                        labelCol: { span: 4 },
                        wrapperCol: { span: 20 },
                        label: "备注",
                        prop: "remark",
                      },
                    },
                    [
                      _c("a-input", {
                        model: {
                          value: _vm.formState.remark,
                          callback: function ($$v) {
                            _vm.$set(_vm.formState, "remark", $$v)
                          },
                          expression: "formState.remark",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }